module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-c20091b8.png";